<template>
  <div>
    <div class="box pay_bg" :style="topStyle" :class="{mt0: productType=='5' || ori_str == 'continueEdu' || orgType == 'custom'}">
      <div class="wrap w1200  pay_b">
        <!--右侧-->
        <EnrollPayInfo :businessID="businessId" :productID="productId" v-if="productType=='1'"  @success = "getInfoSuccess"></EnrollPayInfo>
        <LivePlayPayInfo :businessID="businessId" :productID="productId" v-if="productType=='2'"  @success = "getInfoSuccess"></LivePlayPayInfo>
        <CoursePayInfo :businessID="businessId" :productID="productId" v-if="productType=='3'"  @success = "getInfoSuccess"></CoursePayInfo>
        <ExamPayInfo :businessID="businessId" :productID="productId" v-if="productType=='4'"  @success = "getInfoSuccess"></ExamPayInfo>
        <PlanPayInfo :businessID="businessId" :productID="productId" v-if="productType=='5'"  @success = "getInfoSuccess"></PlanPayInfo>
        <div class="pay_away">
          <dl>
            <dt>选择支付方式</dt>
            <dd><input name="pay_type" type="radio" value="0" v-model="payType" />  <img src="@/assets/images/alipay@2x.png" width="33" height="32" />　支付宝</dd>
            <!-- <dd><input name="pay_type" type="radio" value="1" v-model="payType" />  <img src="@/assets/images/wxpay@2x.png" width="34" height="31" />　微信支付</dd> -->
            <p class="line">
              <input type="button" value="确认支付" class="go_btn" v-debounce-click @click="buy(productType, payType, object)"/>
            </p>
          </dl>
        </div>
        <!--/右侧-->
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
import LivePlayPayInfo from '@/page/modules/livePlay/pay_info.vue'
import CoursePayInfo from '@/page/modules/course/pay_info.vue'
import ExamPayInfo from '@/page/modules/exam/pay_info.vue'
import EnrollPayInfo from '@/page/modules/enroll/pay_info.vue'
import PlanPayInfo from '@/page/modules/plan/pay_info.vue'
import { mapState } from 'vuex'
import { getCookie } from '@/store/cookies.js'
import urlutils from '@/utils/urlencode'
export default {
  components: { CoursePayInfo, LivePlayPayInfo, ExamPayInfo, EnrollPayInfo, PlanPayInfo },
  data () {
    return {
      payType: '0',
      object: {},
      productId: this.$route.params.id,
      businessId: this.$route.params.businessId,
      productType: this.$route.params.type,
      orgType: this.$route.params.orgType,
      payResultUrl: '',
      returnPath: this.$route.params.result_url,
      sign: this.$route.params.sign,
      ori_str: ''
    }
  },
  created () {
    this.payResultUrl= this.generateReturnPath(this.orgType)
    this.ori_str = this.$utils.judgementOri(this.orgType)
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  computed: {
    ...mapState('auth', ['user']),
    topStyle () {
      if (this.ori_str == 'entrain') {
        return {
          marginTop: '121px'
        }
      }
      return {}
    }
  },
  methods: {
    getInfoSuccess (r) {
      if (r && r != '') {
        this.object = r
      }
    },
    generateReturnPath (orgType) {
      console.log(orgType,'orgType')
      if (orgType == '1') { // 职称教育
        return window.location.origin + '/#/continueEdu/payResult'
      } else if (orgType == '2') { // 安全教育
        return window.location.origin + '/#/byl/payResult'
      } else if (orgType == '3') { // 企业内训
        return window.location.origin + '/#/entrain/payResult'
      } else if (orgType == '4') { // 党建教育
        return window.location.origin + '/#/byl/payResult'
      } else if (orgType == 'custom') {
        return window.location.origin + '/payResult'
      } else {
        return window.location.origin + '/#/byl/payResult'
      }

    },
    buy (productType, payType, object) {
      var path = getCookie('org') ? this.$OR.getUrl(getCookie('org').businessId) : ''
      var domain = this.$utils.getQueryString('domain') || process.env.DEFAULT_ORGCODE
      this.$api.post(this.$global.paymentApiPath, '/paycenter/getPayState', {businessId: this.businessId}, r => {
        let userId = (this.user) ? this.user.id : getCookie(process.env.USERID_KEY)
        var redirectUrl = this.$global.paymentApiPath + '/paycenter/payByAli?businessId=' + this.businessId + '&money=' + parseFloat(object.money).toFixed(2) + '&subject=' + object.subject + '&type=' + productType + '&domain=' + domain +
          '&returnUrl=' + encodeURIComponent(this.payResultUrl) + '&domainHref=' + urlutils.url_coded(this.returnPath) + '&token=' + getCookie(process.env.TOKEN_KEY) + '&sign=' + this.sign

       if (r.data) {
          if (r.data.payResult == '0') {
            this.$api.post(this.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: this.businessId}, r => {
              if (payType=='0') { // 支付宝支付
                window.open(redirectUrl, '_blank');
              } else if (payType=='1') { // 微信支付
                this.$api.post(this.$global.paymentApiPath, '/paycenter/payByWeChat', {businessId: this.businessId, money: parseFloat(object.money).toFixed(2), subject: object.subject, type: productType, userId: userId, sign: this.sign}, r => {
                  let qrCodeUrl = r.data
                  let routeData = this.$router.resolve({
                    // name: "微信支付",
                    path: path + '/wxPay',
                    query: {
                      businessId: this.businessId,
                      type: this.productType,
                      qrCode: qrCodeUrl,
                      money: parseFloat(object.money).toFixed(2),
                      subject: object.subject,
                      returnUrl: this.payResultUrl,
                      domainHref: this.returnPath,
                      sign: this.sign,
                      domain: domain
                    }
                    // params:{catId:params.catId}
                  });
                  window.open(routeData.href, '_blank');
                })
              }
            }, e => {
              if (e=='PAY_ERROR_00014') {
                this.$toasted.show('该订单已完成支付，请联系管理员', {
                  duration: 800
                })
              }
            })
          } else if (r.data.payResult == '1') {
            window.location.replace(this.returnPath);
          }
        } else {
          if (payType=='0') { // 支付宝支付
            window.open(redirectUrl, '_blank');
          } else if (payType=='1') { // 微信支付
            this.$api.post(this.$global.paymentApiPath, '/paycenter/payByWeChat', {businessId: this.businessId, money: parseFloat(object.money).toFixed(2), subject: object.subject, type: productType, userId: userId, sign: this.sign}, r => {
              let qrCodeUrl = r.data
              let routeData = this.$router.resolve({
                // name: "微信支付",
                path: path + '/wxPay',
                query: {
                  businessId: this.businessId,
                  type: this.productType,
                  qrCode: qrCodeUrl,
                  money: parseFloat(object.money).toFixed(2),
                  subject: object.subject,
                  returnUrl: this.payResultUrl,
                  domainHref: this.returnPath,
                  sign: this.sign,
                  domain: domain
                }
                // params:{catId:params.catId}
              });
              window.open(routeData.href, '_blank');
            })
          }
        }
      })
    }
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/page/modules/pay/pay.vue